import React, {useEffect, useState} from 'react';
import {observer} from 'mobx-react-lite';
import LoadingComponent from "../layout/components/widget/LoadingComponent";
import {ProtectedRouteProps} from "../../entity/props/core/protected-route-props";
import {useService} from "../../infrastructure/service/service";
import {useNavigate} from "react-router-dom";

const ProtectedRoute: React.FC<ProtectedRouteProps> = (props: ProtectedRouteProps): any => {
  const { userService, subscriptionService } = useService();
  const navigate = useNavigate();

  const [validSubscription, setValidSubscription] = useState<boolean | null>(null);

  useEffect(() => {
    const init = async () => {
      const user = await userService.getCurrentUser();

      const validSubscription = await subscriptionService.validateSubscriptions(user?.organizationID ?? '');
      setValidSubscription(validSubscription);
    };

    init();
  }, [subscriptionService]);

  if (validSubscription === null)
    return props.children;

  return (
      userService.isLoggedIn()
          ? validSubscription
              ? props.children
              : navigate(`/subscription${!userService.isAdminUser() ? '/expired' : ''}`)
          : <LoadingComponent />
  );
};

export default observer(ProtectedRoute);
